<template>
  <div style="height: 100%" class="container">
    <listFilter
      :formItems="formItems"
      :filter="filter"
      @searchTableInfo="searchTableInfo"
      @resetTableInfo="resetTableInfo"
      @exportExcel="exportExcel"
    ></listFilter>
    <div class="userMangeTable" style="height: calc(100% - 121px)">
      <div class="menuTree" style="height: 100%">
        <MenuTree
          :dataSource="treeData"
          @handleTreeClick="handleTreeClick"
          :activedTree="activedTree"
        />
      </div>
      <div class="tableBox">
        <Table
          class="nihao"
          border
          :columns="columns"
          size="small"
          stripe
          :data="dataSource"
          disabled-hover
        ></Table>
        <div style="margin: 10px; overflow: hidden">
          <div style="float: right">
            <Page
              show-total
              :total="totalCount"
              :current="filter.pageIndex"
              :page-size="filter.pageSize"
              @on-change="changePage"
            ></Page>
          </div>
        </div>
      </div>
    </div>
    <Modal
      v-model="permissionmodalVisible"
      :title="setPermissionTitle"
      :mask-closable="false"
      @on-cancel="permissionCancel"
      fullscreen
      :closable="false"
    >
      <PermissionSetting
        ref="permissionSettingRef"
        :userId="currentUserId"
        v-if="permissionmodalVisible"
      />
      <div slot="footer">
        <Button @click="permissionCancel">取消</Button>
      </div>
    </Modal>
    <Modal
      v-model="permissionRoleModalVisible"
      :title="roleSettingTitle"
      :mask-closable="false"
      @on-cancel="permissionRoleModalClose"
      fullscreen
      :closable="false"
    >
      <PermissionRoles
        ref="permissionRolesRef"
        :userId="currentUserId"
        v-if="permissionRoleModalVisible"
      />
      <div slot="footer">
        <Button @click="permissionRoleModalClose">取消</Button>
      </div>
    </Modal>
    <SetAppAuth v-if="appAuthModalVisible" :visible.sync="appAuthModalVisible" :userId="currentUserId" />
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import util from '@/assets/js/util';
import getPermissionMixin from '@/mixins/getPermissionMixin';
import MenuTree from '@/components/menu-tree';
import PermissionSetting from './components/PermissionSetting.vue';
import PermissionRoles from './components/PermissionRoles.vue';
import SetAppAuth from './components/SetAppAuth.vue';
import { formItems, getColumns } from './config';
import { getDepartmentData } from '@/api/userManage.js';

export default {
  name: 'reportList',
  mixins: [getPermissionMixin],
  components: { MenuTree, PermissionSetting, PermissionRoles, SetAppAuth },
  data() {
    return {
      tableName: 'usersList',
      filter: {
        pageIndex: 1,
        pageSize: 10,
        dictType: '91通讯录'
      },
      formItems,
      columns: [],
      permissionmodalVisible: false,
      appAuthModalVisible: false,
      currentUserId: '',
      currentRealName: '',
      permissionRoleModalVisible: false
    };
  },
  computed: {
    ...mapState('userManage', [
      'treeData',
      'activedTree',
      'totalCount',
      'dataSource'
    ]),
    setPermissionTitle () {
      return this.currentRealName ? `分配权限 - ${this.currentRealName}` : '分配权限';
    },
    roleSettingTitle () {
      return this.currentRealName ? `角色分配 - ${this.currentRealName}` : '角色分配';
    }
  },
  methods: {
    ...mapMutations('userManage', ['SAVE_STATE']),
    ...mapActions('userManage', [
      'getUserPermission',
      'getTreeList',
      'getTableInfo',
      'getDepartmentData'
    ]),
    async permissionCancel () {
      const ref = this.$refs.permissionSettingRef;
      await ref.systemChange();
      this.permissionmodalVisible = false;
    },
    searchTableInfo() {
      this.filter.pageIndex = 1;
      this.getTableInfo({ filter: this.filter });
    },
    resetTableInfo() {
      this.filter = {
        pageIndex: 1,
        pageSize: 10,
        relationId: this.activedTree.relationId
      };
      this.getTableInfo({ filter: this.filter });
    },
    // 翻页
    changePage(num) {
      this.filter.pageIndex = num;
      this.getTableInfo({ filter: this.filter });
    },
    handleTreeClick(item) {
      this.filter = {
        ...this.filter,
        pageIndex: 1,
        relationId: item.relationId
      };
      this.getTableInfo({ filter: this.filter });
      this.SAVE_STATE({ activedTree: item });
    },
    pageInit() {
      this.getTreeList().then(({ treeData }) => {
        this.SAVE_STATE({ activedTree: treeData[0] });
        this.filter = { ...this.filter, relationId: treeData[0].relationId };
        this.getTableInfo({ filter: this.filter });
      });
      // 可以.then 然后调用对应的接口获取table
    },
    setPermission({ id: userId, realName }) {
      this.currentRealName = realName;
      this.currentUserId = userId;
      this.permissionmodalVisible = true;
    },
    // 应用分配
    setAppAuth ({ id: userId }) {
      this.currentUserId = userId;
      this.appAuthModalVisible = true;
    },
    setRolePermission({ id: userId, realName }) {
      this.currentRealName = realName;
      this.currentUserId = userId;
      this.permissionRoleModalVisible = true;
    },
    callBack(res) {
      const arr =
        res.tableDataColMap == null
          ? []
          : util.getFirstDataByObj(res.tableDataColMap) || [];
      const noShowArr = arr.map(item => item.colName);
      this.columns = getColumns(
        {
          setPermission: this.setPermission,
          setRole: this.setRolePermission,
          setAppAuth: this.setAppAuth
        },
        noShowArr
      );
    },
    exportExcel() {
      util.fileDownload(
        this.$ajax,
        '/v1/orgUserAuth/export',
        this.filter,
        '用户管理'
      );
    },
    async permissionRoleModalClose() {
      const ref = this.$refs.permissionRolesRef;
      await ref.systemChange();
      this.permissionRoleModalVisible = false;
      this.getTableInfo({ filter: this.filter });
    },
    // 自定义部门的数据
    getDepartmentInfo ({ commit, dispatch, state }, payload) {
      return new Promise(resolve => {
        getDepartmentData().then(res => {
          const { code, data } = res.data;
          if (code == 200) {
            const dataMap = data.map(item => {
              const { childDepartmentId, childDepartmentName, departmentId, checked, ...rest } = item;
              return {
                ...rest,
                id: childDepartmentId,
                title: childDepartmentName,
                pid: departmentId,
                toggleOpen: false,
                active: false,
                checked: false, // 需要给个初始值,TODO：要后端返回用来反显
                level: 0
              };
            });
            const addIntiData = [...dataMap];
            const treeData = util.getMenuTree(addIntiData);
            resolve({ originData: dataMap, treeData });
          }
        });
      });
    }
  },
  created() {
    this.pageInit();
  }
};
</script>
<style lang="less" scoped>
.container {
  padding: 0 20px;
}
.userMangeTable {
  display: flex;
  padding: 10px 0;
  background-color: #fff;
  .tableBox {
    height: 100%;
    // 使用～是因为less时会自动转换成相同单位进行运算， 也就是100% - 265%
    width: calc(~'100% - 265px');
    overflow-y: auto;
  }
}
.item-active {
  border: 0px !important;
}
</style>
